import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-Bdd3DKjH.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui--CloseButton--ar-AE" */'./ar-AE-D8JU3fMw.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui--CloseButton--de-DE" */'./de-DE-jqt0JUIa.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui--CloseButton--en-AU" */'./en-AU-B9QGOBZg.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui--CloseButton--en-CA" */'./en-CA-BAYFw6Sq.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui--CloseButton--en-GB" */'./en-GB-BVFTnirm.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui--CloseButton--en-IN" */'./en-IN-1-dN-vzc.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui--CloseButton--en-SG" */'./en-SG-DB5jN9_8.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui--CloseButton--es-CO" */'./es-CO-CnviORnG.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui--CloseButton--es-ES" */'./es-ES-Ci-RMvQD.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui--CloseButton--es-MX" */'./es-MX-DvOqbjER.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui--CloseButton--fr-CA" */'./fr-CA-CPlJMAkO.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui--CloseButton--fr-FR" */'./fr-FR-Cz2iPts3.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui--CloseButton--hi-IN" */'./hi-IN-DMstniB_.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui--CloseButton--it-IT" */'./it-IT-Bugr8geC.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui--CloseButton--ja-JP" */'./ja-JP-C-c14XPW.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui--CloseButton--ko-KR" */'./ko-KR-Ds_s6rl4.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui--CloseButton--nl-NL" */'./nl-NL-BoHI8VQk.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui--CloseButton--pl-PL" */'./pl-PL-TKxy-fG_.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui--CloseButton--pt-BR" */'./pt-BR-uACNADt-.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui--CloseButton--sv-SE" */'./sv-SE-sG_MCY-j.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui--CloseButton--ta-IN" */'./ta-IN-DWk0Kv5J.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui--CloseButton--th-TH" */'./th-TH-D6cVjCxH.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui--CloseButton--tr-TR" */'./tr-TR-BsQlKR1a.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui--CloseButton--vi-VN" */'./vi-VN-CXO4oDav.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui--CloseButton--zh-CN" */'./zh-CN-CQ1d9_aQ.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui--CloseButton--zh-TW" */'./zh-TW-Del0IdFx.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-A6SlLYFV.js.map
